import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

/** Classe à passer à `modalDialogClass` avec {@link MODAL_FILL_VIEWPORT_HEIGHT_OPTIONS}. */
export const MODAL_DIALOG_FILL_VIEWPORT_HEIGHT_CLASS = 'modal-dialog-fill-viewport-height';

/**
 * Options NgbModal pour occuper ~100 % de la hauteur de la fenêtre (avec le composant
 * {@link ModalContainerComponent} et `[fillViewportHeight]="true"`).
 */
export const MODAL_FILL_VIEWPORT_HEIGHT_OPTIONS: NgbModalOptions = {
  centered: true,
  size: 'xl',
  modalDialogClass: MODAL_DIALOG_FILL_VIEWPORT_HEIGHT_CLASS,
};

@Component({
  selector: 'app-modal-container',
  standalone: true,
  imports: [],
  templateUrl: './modal-container.component.html',
  styleUrl: './modal-container.component.scss',
})
export class ModalContainerComponent {
  @Input() title: string = 'Modal Title'; // Titre de la modale
  @Input() subtitle?: string = '';
  @Input() showFooter: boolean = false; // Afficher ou non le footer
  @Input() fullScreen: boolean = false;
  /**
   * À utiliser dans un NgbModal : le dialogue remplit la hauteur de l’écran (voir
   * `MODAL_FILL_VIEWPORT_HEIGHT_OPTIONS` + styles globaux `.modal-dialog-fill-viewport-height`).
   */
  @Input() fillViewportHeight: boolean = false;
  @Output() dismissModal = new EventEmitter<void>();

  // Fermer la modale
  closeModal(): void {
    this.dismissModal.emit();
  }
}
